import React from 'react';
export function Hero() {
  return <div className="text-center z-10 relative mt-24 mb-8 md:mb-16 px-4" data-id="element-42">
      <h2 className="font-bold text-base md:text-lg mb-2 text-black" data-id="element-43">
        Something Amazing Coming Soon
      </h2>
      <h1 className="text-6xl md:text-[5.5rem] font-black tracking-tighter mb-2 text-black leading-none" data-id="element-44">
        KRAYA
      </h1>
      <p className="text-lg md:text-xl text-black font-normal" data-id="element-45">
        India's #1st social food app on college campuses
      </p>
    </div>;
}